const en_whs_itemmove = {
    "": "item transfer",
    detail: "item transfer detail",
}

export default en_whs_itemmove;